import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-038df1e9")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("svg", {
    "aria-hidden": "true",
    class: `icon ${_ctx.color.indexOf('#')>-1?'':_ctx.color}`,
    style: {'font-size':_ctx.fontSize,fill:_ctx.color.indexOf('#')>-1?_ctx.color:'',width:_ctx.fontSize,height:_ctx.fontSize}
  }, [
    _createVNode("title", null, _toDisplayString(_ctx.title), 1),
    _createVNode("use", { "xlink:href": _ctx.symbolId }, null, 8, ["xlink:href"])
  ], 6))
})